/* Petgross Para: product variants and Ajax cart reward preview. */
(function () {
  'use strict';
  if (window.__pgRewardInitialized) return;
  window.__pgRewardInitialized = true;

  var formatter = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  function formatReward(priceInKurus) {
    var amount = Number(priceInKurus);
    if (!Number.isFinite(amount) || amount < 0) amount = 0;
    var rewardKurus = Math.round(amount * 0.02);
    return formatter.format(rewardKurus / 100) + ' TL';
  }

  function amountElement(box) {
    return box.querySelector('[data-pg-reward-amount]');
  }

  function updateBox(box, priceInKurus) {
    var amount = amountElement(box);
    if (amount) {
      var newText = formatReward(priceInKurus);
      if (amount.textContent !== newText) amount.textContent = newText;
    }
  }

  function setupProducts() {
    document.querySelectorAll('[data-pg-reward-product]').forEach(function (box) {
      if (box.dataset.pgRewardBound === '1') return;
      box.dataset.pgRewardBound = '1';
      var variants = [];
      try {
        var json = box.querySelector('[data-pg-reward-variants]');
        variants = json ? JSON.parse(json.textContent) : [];
      } catch (error) { variants = []; }
      var priceById = {};
      variants.forEach(function (variant) {
        priceById[String(variant.id)] = Number(variant.price);
      });

      var sectionId = box.dataset.pgSectionId || '';
      var productRoot = box.closest('[id^="MainProduct-"]');
      if (!productRoot) return;
      var form = document.getElementById('product-form-' + sectionId);

      function updateFromForm() {
        if (!form) form = document.getElementById('product-form-' + sectionId);
        var input = form ? form.querySelector('input[name="id"]') : null;
        var id = input ? String(input.value) : '';
        if (Object.prototype.hasOwnProperty.call(priceById, id)) {
          updateBox(box, priceById[id]);
        }
      }

      function delayedUpdate() {
        window.requestAnimationFrame(updateFromForm);
        window.setTimeout(updateFromForm, 100);
        window.setTimeout(updateFromForm, 350);
      }

      productRoot.addEventListener('change', delayedUpdate);
      productRoot.addEventListener('input', function (event) {
        if (event.target.matches('select, input[type="radio"], input[name="id"]')) {
          delayedUpdate();
        }
      });
      productRoot.addEventListener('variant:change', function (event) {
        var variant = event.detail && (event.detail.variant || event.detail.currentVariant);
        if (variant && typeof variant.price !== 'undefined') updateBox(box, variant.price);
        else delayedUpdate();
      });
      // Minion can replace price HTML and change hidden IDs after a variant selection.
      var priceRoot = document.getElementById('price-' + sectionId);
      if (priceRoot && 'MutationObserver' in window) {
        var priceObserver = new MutationObserver(delayedUpdate);
        priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
      }
      if (form && 'MutationObserver' in window) {
        var formObserver = new MutationObserver(function (changes) {
          if (changes.some(function (m) {
            return m.target && m.target.matches && m.target.matches('input[name="id"]');
          })) delayedUpdate();
        });
        formObserver.observe(form, { attributes: true, attributeFilter: ['value'], subtree: true });
      }
      updateFromForm();
    });
  }

  var cartTimer = null;
  var cartRequestId = 0;
  var watchedCartRoots = new WeakSet();

  async function refreshCart() {
    var boxes = document.querySelectorAll('[data-pg-reward-cart]');
    if (!boxes.length) return;
    var url = boxes[0].dataset.pgCartUrl || '/cart.js';
    var id = ++cartRequestId;
    try {
      var response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) return;
      var cart = await response.json();
      if (id !== cartRequestId) return;
      document.querySelectorAll('[data-pg-reward-cart]').forEach(function (box) {
        box.hidden = !Number(cart.item_count);
        updateBox(box, cart.total_price);
      });
    } catch (error) { /* Liquid-rendered amount remains available. */ }
  }

  function queueCartRefresh(delay) {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(refreshCart, typeof delay === 'number' ? delay : 350);
  }

  function setupCartObservers() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('cart-drawer, #main-cart-footer, #main-cart-items').forEach(function (root) {
      if (watchedCartRoots.has(root)) return;
      watchedCartRoots.add(root);
      var observer = new MutationObserver(function (mutations) {
        var actualCartChange = mutations.some(function (mutation) {
          var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          if (!target || (target.closest && target.closest('.pg-reward-card'))) return false;
          if (mutation.addedNodes.length && Array.from(mutation.addedNodes).every(function (node) {
            return node.nodeType === 1 && node.matches && node.matches('script, style, link');
          })) return false;
          return true;
        });
        if (actualCartChange) queueCartRefresh(450);
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('cart-drawer, #main-cart-items, #main-cart-footer')) {
      queueCartRefresh(600);
      window.setTimeout(refreshCart, 1350);
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(
      'cart-remove-button, .quantity__button, .drawer__cart-remove-button, .product-form__submit, [name="add"]'
    );
    if (target) {
      queueCartRefresh(600);
      window.setTimeout(refreshCart, 1400);
    }
  });
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update'].forEach(function (eventName) {
    document.addEventListener(eventName, function () { queueCartRefresh(150); });
  });
  document.addEventListener('shopify:section:load', function () {
    setupProducts();
    setupCartObservers();
    queueCartRefresh(150);
  });
  window.addEventListener('pageshow', function () { queueCartRefresh(100); });

  function init() {
    setupProducts();
    setupCartObservers();
    queueCartRefresh(150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
